import React from 'react';
import { Guitar as GuitarType } from './mockData';

interface CollectionStatsProps {
  guitars: GuitarType[];
}

export default function CollectionStats({ guitars }: CollectionStatsProps) {
  const active = guitars.filter((g) => g.status === 'active').length;
  const onLoan = guitars.filter((g) => g.status === 'on-loan').length;
  const forSale = guitars.filter((g) => g.status === 'for-sale').length;
  const archived = guitars.filter((g) => g.status === 'archived').length;
  const totalValue = guitars
    .filter((g) => g.status !== 'archived')
    .reduce((s, g) => s + g.purchasePrice, 0);

  return (
    <div className="flex flex-wrap gap-2">
      <div className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border rounded-lg text-sm">
        <span className="w-2 h-2 rounded-full bg-positive" />
        <span className="text-muted-foreground">Active:</span>
        <span className="font-700 text-foreground tabular-nums">{active}</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border rounded-lg text-sm">
        <span className="w-2 h-2 rounded-full bg-info" />
        <span className="text-muted-foreground">On Loan:</span>
        <span className="font-700 text-foreground tabular-nums">{onLoan}</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border rounded-lg text-sm">
        <span className="w-2 h-2 rounded-full bg-warning" />
        <span className="text-muted-foreground">For Sale:</span>
        <span className="font-700 text-foreground tabular-nums">{forSale}</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 bg-card border border-border rounded-lg text-sm">
        <span className="w-2 h-2 rounded-full bg-muted-foreground" />
        <span className="text-muted-foreground">Archived:</span>
        <span className="font-700 text-foreground tabular-nums">{archived}</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/20 rounded-lg text-sm">
        <span className="text-muted-foreground">Vault Value:</span>
        <span className="font-700 text-primary tabular-nums">${totalValue.toLocaleString('en-US')}</span>
      </div>
    </div>
  );
}